import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function RiskMetricChartIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M8.5 9C9.32843 9 10 9.67157 10 10.5C10 11.3284 9.32843 12 8.5 12L6.5 12C5.67157 12 5 11.3284 5 10.5C5 9.67157 5.67157 9 6.5 9L8.5 9Z"
        fill="#927BF0"
      />
      <path
        d="M15.5 9C16.3284 9 17 9.67157 17 10.5C17 11.3284 16.3284 12 15.5 12L13.5 12C12.6716 12 12 11.3284 12 10.5C12 9.67157 12.6716 9 13.5 9L15.5 9Z"
        fill="#CCBFFF"
      />
      <path
        d="M22.5 9C23.3284 9 24 9.67157 24 10.5C24 11.3284 23.3284 12 22.5 12L20.5 12C19.6716 12 19 11.3284 19 10.5C19 9.67157 19.6716 9 20.5 9L22.5 9Z"
        fill="#CCBFFF"
      />
      <path
        d="M29.5 9C30.3284 9 31 9.67157 31 10.5C31 11.3284 30.3284 12 29.5 12L27.5 12C26.6716 12 26 11.3284 26 10.5C26 9.67157 26.6716 9 27.5 9L29.5 9Z"
        fill="#927BF0"
      />
      <path
        d="M8.5 14C9.32843 14 10 14.6716 10 15.5C10 16.3284 9.32843 17 8.5 17L6.5 17C5.67157 17 5 16.3284 5 15.5C5 14.6716 5.67157 14 6.5 14L8.5 14Z"
        fill="#CCBFFF"
      />
      <path
        d="M15.5 14C16.3284 14 17 14.6716 17 15.5C17 16.3284 16.3284 17 15.5 17L13.5 17C12.6716 17 12 16.3284 12 15.5C12 14.6716 12.6716 14 13.5 14L15.5 14Z"
        fill="#927BF0"
      />
      <path
        d="M22.5 14C23.3284 14 24 14.6716 24 15.5C24 16.3284 23.3284 17 22.5 17L20.5 17C19.6716 17 19 16.3284 19 15.5C19 14.6716 19.6716 14 20.5 14L22.5 14Z"
        fill="#927BF0"
      />
      <path
        d="M29.5 14C30.3284 14 31 14.6716 31 15.5C31 16.3284 30.3284 17 29.5 17L27.5 17C26.6716 17 26 16.3284 26 15.5C26 14.6716 26.6716 14 27.5 14L29.5 14Z"
        fill="#CCBFFF"
      />
      <path
        d="M8.5 19C9.32843 19 10 19.6716 10 20.5C10 21.3284 9.32843 22 8.5 22L6.5 22C5.67157 22 5 21.3284 5 20.5C5 19.6716 5.67157 19 6.5 19L8.5 19Z"
        fill="#927BF0"
      />
      <path
        d="M15.5 19C16.3284 19 17 19.6716 17 20.5C17 21.3284 16.3284 22 15.5 22L13.5 22C12.6716 22 12 21.3284 12 20.5C12 19.6716 12.6716 19 13.5 19L15.5 19Z"
        fill="#CCBFFF"
      />
      <path
        d="M22.5 19C23.3284 19 24 19.6716 24 20.5C24 21.3284 23.3284 22 22.5 22L20.5 22C19.6716 22 19 21.3284 19 20.5C19 19.6716 19.6716 19 20.5 19L22.5 19Z"
        fill="#CCBFFF"
      />
      <path
        d="M29.5 19C30.3284 19 31 19.6716 31 20.5C31 21.3284 30.3284 22 29.5 22L27.5 22C26.6716 22 26 21.3284 26 20.5C26 19.6716 26.6716 19 27.5 19L29.5 19Z"
        fill="#927BF0"
      />
      <path
        d="M8.5 24C9.32843 24 10 24.6716 10 25.5C10 26.3284 9.32843 27 8.5 27L6.5 27C5.67157 27 5 26.3284 5 25.5C5 24.6716 5.67157 24 6.5 24L8.5 24Z"
        fill="#927BF0"
      />
      <path
        d="M15.5 24C16.3284 24 17 24.6716 17 25.5C17 26.3284 16.3284 27 15.5 27L13.5 27C12.6716 27 12 26.3284 12 25.5C12 24.6716 12.6716 24 13.5 24L15.5 24Z"
        fill="#CCBFFF"
      />
      <path
        d="M22.5 24C23.3284 24 24 24.6716 24 25.5C24 26.3284 23.3284 27 22.5 27L20.5 27C19.6716 27 19 26.3284 19 25.5C19 24.6716 19.6716 24 20.5 24L22.5 24Z"
        fill="#927BF0"
      />
      <path
        d="M29.5 24C30.3284 24 31 24.6716 31 25.5C31 26.3284 30.3284 27 29.5 27L27.5 27C26.6716 27 26 26.3284 26 25.5C26 24.6716 26.6716 24 27.5 24L29.5 24Z"
        fill="#CCBFFF"
      />
    </svg>
  );
};
